import { DURATION_MULTIPLIERS } from './BusinessTariffs.constants';
import type { Package, PackagesListData } from '@/api/types/business.types';

export function getShopPackagesFromData(
  data: PackagesListData | null | undefined
): Package[] | null {
  return (
    data?.packagesList?.find(pl => pl.segment === 'Shop')?.packages ?? null
  );
}

function normalizeTariffName(name: string): string {
  return name.toLowerCase().replace('+', '_plus');
}

export function getPackageByName(
  packages: Package[] | null,
  name: string
): Package | null {
  if (!packages) return null;
  const key = name.toLowerCase();
  return packages.find(p => normalizeTariffName(p.name) === key) ?? null;
}

export function getInitialTariffFromData(
  data: PackagesListData | null | undefined
): string {
  const packages = getShopPackagesFromData(data);
  return packages?.length ? normalizeTariffName(packages[0].name) : '';
}

export function getDurationMultiplier(duration: string): number {
  return DURATION_MULTIPLIERS[duration] ?? 1;
}

const formatPrice = (price: number) => `${price.toLocaleString('ru-RU')} AZN`;

export function getCalculatedPrice(
  pkg: Package | null,
  duration: string
): string {
  const period = pkg?.periods.find(p => p.value?.toString() === duration);
  return period ? formatPrice(period.price) : '0 AZN';
}

function multiplyOptional(
  value: number | null | undefined,
  mult: number
): number | null {
  return value != null ? value * mult : null;
}

export function getCalculatedWalletAmount(
  pkg: Package | null,
  durationMultiplier: number
): string | null {
  const amount = multiplyOptional(pkg?.walletAmount, durationMultiplier);
  return amount != null ? `${amount} AZN` : null;
}

export function getCalculatedPaidAdsCount(
  pkg: Package | null,
  durationMultiplier: number
): number | null {
  return multiplyOptional(pkg?.paidAdsCount, durationMultiplier);
}

export function getTariffNames(packages: Package[] | null): string[] {
  return packages?.length ? packages.map(p => normalizeTariffName(p.name)) : [];
}

export interface PillPosition {
  left: number;
  width: number;
}

export function getPillPositionFromContainer(
  container: HTMLElement,
  selectedDuration: string
): PillPosition | null {
  const btn = container.querySelector<HTMLButtonElement>(
    `[data-days="${selectedDuration}"]`
  );
  if (!btn) return null;
  const cr = container.getBoundingClientRect();
  const br = btn.getBoundingClientRect();
  const scrollLeft = container.scrollLeft ?? 0;
  return {
    left: br.left - cr.left + scrollLeft,
    width: br.width,
  };
}
